import { GoAButton } from '@abgov/react-components';
import { PropsWithChildren } from 'react';
import { SectionKey } from './SideBar';
import styles from './DetailsContainer.module.scss';
const { container } = styles;
type DetailsContainerProps = PropsWithChildren<{
  section: SectionKey;
  activeSection: SectionKey | null;
  setActiveSection: (section: SectionKey | null) => void;

  saveDisabled?: boolean;
  onEdit?: () => void;
  onSave?: () => void;
  onCancel?: () => void;
}>;

const DetailsContainer = ({
  section,
  activeSection,
  setActiveSection,
  children,

  saveDisabled,
  onEdit,
  onSave,
  onCancel,
}: DetailsContainerProps) => {
  const isEditing = activeSection === section;
  const isAnotherEditing = activeSection !== null && activeSection !== section;
  return (
    <div>
      <div className={container}>
        {!isEditing && (
          <GoAButton type='tertiary' onClick={() => setActiveSection(section)} disabled={isAnotherEditing}>
            Edit
          </GoAButton>
        )}

        {isEditing && onSave && onCancel && (
          <>
            <GoAButton
              type='tertiary'
              onClick={() => {
                onSave?.();
              }}
              disabled={saveDisabled}
            >
              Save
            </GoAButton>
            <GoAButton
              type='tertiary'
              onClick={() => {
                onCancel?.();
              }}
            >
              Cancel
            </GoAButton>
          </>
        )}
      </div>

      <div>{children}</div>
    </div>
  );
};
export default DetailsContainer;
